import { BenchmarkingReportSettings } from '@/hooks'

export const shouldDisplayComparedToSetting = (
    reportSettings: BenchmarkingReportSettings
) => {
    return ['average', 'totals'].includes(reportSettings.analysisType)
}
